module.exports = __webpack_public_path__ + "static/work12-1677afe3460ef48b207efb2bedc2a37b.jpg";